import React, { FC } from 'react';
import { Button, Space, Table, TablePaginationConfig, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { EditOutlined } from '@ant-design/icons';

import { IDistribution } from 'types/distribution.types';
import { getOptionLabel } from 'utils/format';
import { audienceOptions, genderOptions } from 'constants/distribution';
import { citiesSelector } from '../../../../store/dictionaries/dictionaries.selectors';
import { useAppSelector } from '../../../../store';

type DistributionTableProps = {
  data: IDistribution[];
  loading: boolean;
  pagination: TablePaginationConfig;
  onChange: (pagination: TablePaginationConfig, filters: any) => void;
  onEdit: (data: IDistribution) => void;
};

export const DistributionTable: FC<DistributionTableProps> = ({ pagination, loading, data, onChange, onEdit }) => {
  const { options: cities } = useAppSelector(citiesSelector);

  return (
    <Table
      rowKey="id"
      loading={loading}
      pagination={pagination}
      dataSource={data}
      onChange={onChange}
      scroll={{ x: 'max-content' }}
      columns={[
        {
          dataIndex: 'title',
          title: 'Заголовок',
          align: 'center',
        },
        {
          dataIndex: 'text',
          title: 'Текст',
          align: 'center',
        },
        {
          dataIndex: 'dateToSend',
          title: 'Время рассылки',
          render: (date) => (date ? dayjs(date).format('DD.MM.YYYY HH:mm') : null),
          align: 'center',
        },
        {
          title: 'Целевая аудитория',
          align: 'center',
          children: [
            {
              dataIndex: 'cityIds',
              title: 'Город',
              render: (_, { cityIds }) => (
                <div className="cities">
                  {cityIds
                    ? cityIds.map((id) => (cities || []).find((city) => city.key === id)?.label).join(', ')
                    : '-'}
                </div>
              ),
              align: 'center',
            },
            {
              dataIndex: 'audience',
              title: 'Сегментация',
              render: (_, { audience }) => getOptionLabel(audienceOptions, audience),
              align: 'center',
            },
            {
              dataIndex: 'gender',
              title: 'Пол',
              render: (_, { gender }) => getOptionLabel(genderOptions, gender),
              align: 'center',
            },
            {
              dataIndex: 'age',
              title: 'Возраст',
              align: 'center',
              render: (_, { age = {} }) => {
                const { from, to } = age || {};
                return `${from !== undefined ? `от ${from}` : ''} ${to !== undefined ? `до ${to}` : ''}`;
              },
            },
          ],
        },

        {
          title: 'Действия',
          align: 'center',
          render: (_, data) => {
            return (
              <Space>
                {dayjs().isBefore(dayjs(data.dateToSend), 'minute') && (
                  <Tooltip title="Редактировать">
                    <Button type="text" icon={<EditOutlined />} onClick={() => onEdit(data)} />
                  </Tooltip>
                )}
              </Space>
            );
          },
        },
      ]}
    />
  );
};
